"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/supportSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeFifteenSupportSectionGeneratedProps = {
    /** Default: "2s" */
    divDiv0Div0DivDataWowDuration?: string;
    /** Default: "Support for Your" */
    divDiv0Div0DivText?: ReactNode;
    /** Default: "Better Healing" */
    divDiv0Div0DivText2?: ReactNode;
    /** Default: "Mental Health" */
    divDiv0Div0P0PText?: ReactNode;
    /** Default: "Therapy & Counseling" */
    divDiv0Div0P1PText?: ReactNode;
    /** Default: "Medical / Wellness" */
    divDiv0Div0P2PText?: ReactNode;
    /** Default: "Rehabilitation" */
    divDiv0Div0P3PText?: ReactNode;
    /** Default: "" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/round-element-1.svg" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    divImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/round-element-2.svg" */
    divImageWithBasePath1ImageSrc?: string;
    divImageWithBasePath1ImageVisible?: boolean;
    divImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeFifteenSupportSectionGenerated: FC<HomeFifteenSupportSectionGeneratedProps> = ({
    divDiv0Div0DivDataWowDuration = "2s",
    divDiv0Div0DivText = "Support for Your",
    divDiv0Div0DivText2 = "Better Healing",
    divDiv0Div0P0PText = "Mental Health",
    divDiv0Div0P1PText = "Therapy & Counseling",
    divDiv0Div0P2PText = "Medical / Wellness",
    divDiv0Div0P3PText = "Rehabilitation",
    divImageWithBasePath0ImageAlt = "",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/round-element-1.svg",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    divImageWithBasePath1ImageAlt = "",
    divImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/round-element-2.svg",
    divImageWithBasePath1ImageVisible,
    divImageWithBasePath1ImageRenderer,
    divImageWithBasePath1ImageProps,
}) => {
    return (
        <div className="section support-section-fifteen">
            <div className="container">
                <div className="support-content-fifteen wow fadeInUp" data-wow-duration={divDiv0Div0DivDataWowDuration}>
                    {divDiv0Div0DivText}
                    <br />
                    {divDiv0Div0DivText2}
                    <p className="item-one item">{divDiv0Div0P0PText}</p>
                    <p className="item-two item">{divDiv0Div0P1PText}</p>
                    <p className="item-three item">{divDiv0Div0P2PText}</p>
                    <p className="item-four item">{divDiv0Div0P3PText}</p>
                </div>
            </div>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(divImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath1ImageVisible, divImageWithBasePath1ImageRenderer, (
                <SmartImage src={divImageWithBasePath1ImageSrc} alt={divImageWithBasePath1ImageAlt} className="img-fluid element-two" {...(divImageWithBasePath1ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeFifteenSupportSectionGenerated;
